import React from 'react';
import { Formik, Field } from 'formik';
import { TextField } from 'material-ui';

const options = [{
  label: 'Promotion Code',
  name: 'promocode',
  disabled: true
}, {
  label: 'Discount Name',
  name: 'discountName',
  disabled: true
}]


function Discounts({ styles, order }) {
  const { promocode, discountName } = order
  const initialValues = {
    promocode: promocode || '',
    discountName: discountName || '',
  }
return (
    <div>
      <h2>Discounts</h2>
      <div style={{ paddingLeft:'40px', paddingBottom: '20px' }}>
        <Formik
          initialValues={initialValues}
          render={(props) => (
              <div className="row">
                {options.map(({ label, name, disabled }) => (
                  <div className="col-md-6 col-lg-4">
                    <Field name={name}>
                      {({ field, form }) => (
                        <div>
                          <TextField 
                            {...field} 
                            floatingLabelText={label}
                            floatingLabelStyle={styles.floatingLabelStyle}
                            floatingLabelFixed={true}
                            disabled={disabled}
                            />
                          {form.touched[field.name]}
                        </div>
                      )}
                    </Field>
                  </div>
                  ))}
              </div>
          )}
        />
      </div>
    </div>
  )
}

export default Discounts;


// WEBPACK FOOTER //
// ./src/components/orders/Common/Discounts.js